module.exports = __webpack_public_path__ + "static/media/berkadia_style.621e045e.jpg";